<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.city' | translate }}
  </label>
  <input type="text" class="form-control" id="city" formControlName="city"  [ngClass]="{ 'is-invalid': campaignForm.get('city')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
